import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useDownloadCsvReagentsApi, useFetchReagentsApi } from 'api/reagent'
import { Reagent, ReagentSearchForm } from 'entities/reagent'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { reagentColumnInfoList, ReagentTableData } from './reagent_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditReagentForm, NewReagentForm } from './reagent_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const ReagentsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<ReagentSearchForm>()
    const searchForm = useForm<ReagentSearchForm>(params)
    const api = useFetchReagentsApi(searchForm)
    const downloadCsvApi = useDownloadCsvReagentsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<Reagent>()
    const reagentDisplaySetting = useDisplaySetting(reagentColumnInfoList(searchForm), 'Reagent')
    const [selectedReagent, setSelectedReagent] = useState<Reagent>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof ReagentSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`reagents?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (reagent: Reagent) => {
        setSelectedReagent(reagent)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditReagentForm
                reagent={selectedReagent}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />

            <ContentHeader
                headerTitle="試薬"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewReagentForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                props.history.push(`reagent_items`)
                            }}
                        >
                            すべてのロットを表示
                        </Button>
                    </>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={1.2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={reagentDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={reagentDisplaySetting.getColumnLength() + 3}>
                            {api.response.results.map((reagent: Reagent) => {
                                return (
                                    <CheckboxTableRow
                                        key={`reagent-${reagent.id}`}
                                        item={reagent}
                                        multipleCheckForm={multipleCheckForm}
                                        onClickEdit={() => handleClickEdit(reagent)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedReagent(reagent)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ReagentTableData reagent={reagent} displaySetting={reagentDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="RegentItem"
            >
                <Button
                    variant="success"
                    onClick={() => {
                        props.history.push(`reagent_items?reagentId=${multipleCheckForm.ids().join(',')}`)
                    }}
                >
                    選択した試薬のロットを表示
                </Button>
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(ReagentsPage)
